var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectlike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61035 14.2609L7.93535 16.0609C8.23535 16.3609 8.91035 16.5109 9.36035 16.5109H12.2104C13.1104 16.5109 14.0854 15.8359 14.3104 14.9359L16.1103 9.46089C16.4853 8.41089 15.8104 7.51089 14.6854 7.51089H11.6854C11.2354 7.51089 10.8604 7.13589 10.9354 6.61089L11.3104 4.21089C11.4604 3.53589 11.0104 2.78589 10.3354 2.56089C9.73535 2.33589 8.98535 2.63589 8.68535 3.08589L5.61035 7.66089",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78516 14.2633V6.91328C1.78516 5.86328 2.23516 5.48828 3.28516 5.48828H4.03516C5.08516 5.48828 5.53516 5.86328 5.53516 6.91328V14.2633C5.53516 15.3133 5.08516 15.6883 4.03516 15.6883H3.28516C2.23516 15.6883 1.78516 15.3133 1.78516 14.2633Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectlike);
export default __webpack_public_path__ + "static/media/projectlike.50a051d12129e373b1e38c93a93dc53e.svg";
export { ForwardRef as ReactComponent };